import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Auth } from 'aws-amplify'

import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';

import MenuIcon from '@material-ui/icons/Menu';
import LockIcon from '@material-ui/icons/Lock';

import appLogo from '../../../../connect-logo.png'

const drawerWidth = 270;

const styles = theme => ({
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    toolbarRoot: {
        minHeight: 50
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginLeft: 12,
        marginRight: 36,
    },
    menuButtonRight: {
        marginLeft: 36,
        marginRight: 12,
    },
    hide: {
        display: 'none',
    },
    appLogo: {
        flex: '1 1 auto'
    }
});

class AppToolbar extends React.Component {
    signOut = async () => {
        await Auth.signOut().then(data => this.props.onSignOut());
    }
    render() {
        const { classes, sideBarOpen, handleSideBarOpen } = this.props;
        return (
            <AppBar position="absolute" className={classNames(classes.appBar, sideBarOpen && classes.appBarShift)} >
                <Toolbar classes={{ root: classes.toolbarRoot }} disableGutters={!sideBarOpen}>
                    <IconButton color="inherit" aria-label="open drawer" onClick={handleSideBarOpen} className={classNames(classes.menuButton, sideBarOpen && classes.hide)}>
                        <MenuIcon />
                    </IconButton>
                    <Typography className={classes.appLogo} align="center" color="inherit" noWrap>
                        <img src={appLogo} alt="logo" />
                    </Typography>
                    <IconButton color="inherit" aria-label="Log Out" onClick={this.signOut} className={classes.menuButtonRight}>
                        <LockIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
        );
    }
}

AppToolbar.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(AppToolbar);


// WEBPACK FOOTER //
// ./src/Components/Presentation/_Shared/Layout/AppToolbar.js